<style lang="scss">
/* - Default style ——— */
.zoezi-staff {
    display: block;
    margin: 0;
    text-align:center;
}
.zoezi-staff > h2 {
    width: 100%;
    margin: 32px 0;
}
.zoezi-staff .zoezi-staff-person {
    display: block;
    margin-bottom: 10px;
}
.zoezi-staff .zoezi-staff-person > img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    margin: 0 10px 0 0;
}
.zoezi-staff .zoezi-staff-text {
    display: flex;
    flex-direction: column;
    font-size: .9em;
}
.zoezi-staff .zoezi-staff-text > * {
    display: block;
}

.zoezi-staff .zoezi-staff-text > p {
    white-space:pre-wrap;
}

/* — Common element queries ——— */
.zoezi-column.zoezi-sm > .zoezi-staff,
.zoezi-column.zoezi-md > .zoezi-staff,
.zoezi-column.zoezi-lg > .zoezi-staff,
.zoezi-column.zoezi-xl > .zoezi-staff{
    display: flex;
    flex-wrap: wrap;
    gap: 32px;

}
.zoezi-column.zoezi-sm > .zoezi-staff .zoezi-staff-text,
.zoezi-column.zoezi-md > .zoezi-staff .zoezi-staff-text,
.zoezi-column.zoezi-lg > .zoezi-staff .zoezi-staff-text{
    font-size: 1em;
}

/* — Small element queries ——— */
.zoezi-column.zoezi-sm > .zoezi-staff .zoezi-staff-person {
    width: calc(50% - 16px);
    margin-bottom:0;
}

/* — Medium element queries ——— */
.zoezi-column.zoezi-md > .zoezi-staff .zoezi-staff-person {
    width: calc(33.333% - 22px);
    margin-bottom:0;
}

/* — Large element queries ——— */
.zoezi-column.zoezi-lg > .zoezi-staff .zoezi-staff-person {
    width: calc(25% - 24px);
    margin-bottom:0;
}
.zoezi-column.zoezi-lg > .zoezi-staff .zoezi-staff-person > img{
    width: 150px; height:150px;
}

/* — Extra large element queries ——— */
.zoezi-column.zoezi-xl > .zoezi-staff .zoezi-staff-person {
    width: calc(20% - 26px);
    margin-bottom:0;
}
.zoezi-column.zoezi-xl > .zoezi-staff .zoezi-staff-text{
    font-size: 1.1em;
}
.zoezi-column.zoezi-xl > .zoezi-staff .zoezi-staff-person > img{
    width: 200px; height:200px;
}

/* - Tags - */
.zoezi-staff-tags .v-chip {
  font-size: 0.8rem;
  height: 20px;
  padding: 0 8px;
}

/* — Style: Soft ——— */
.zoezi-staff.z-style-soft .zoezi-staff-person > img{width:250px; height:250px; transition: border-radius 1s ease-in-out;}
.zoezi-staff.z-style-soft .zoezi-staff-person:nth-child(5n-3) > img{border-radius:31% 69% 70% 30% / 30% 44% 56% 70%;}
.zoezi-staff.z-style-soft .zoezi-staff-person:nth-child(5n-2) > img{border-radius:41% 59% 33% 67% / 52% 66% 34% 48%;}
.zoezi-staff.z-style-soft .zoezi-staff-person:nth-child(5n-1) > img{border-radius:58% 42% 48% 52% / 52% 56% 44% 48%}
.zoezi-staff.z-style-soft .zoezi-staff-person:nth-child(5n+0) > img{border-radius:80% 20% 35% 65% / 55% 21% 79% 45%}
.zoezi-staff.z-style-soft .zoezi-staff-person:nth-child(5n+1) > img{border-radius:43% 57% 50% 50% / 66% 36% 64% 34%}
.zoezi-staff.z-style-soft .zoezi-staff-person:hover>img{border-radius:50%;}
.zoezi-column.zoezi-lg > .zoezi-staff.z-style-soft .zoezi-staff-person > img{width: 250px; height:250px;}
.zoezi-column.zoezi-xl > .zoezi-staff.z-style-soft .zoezi-staff-person > img{width: 300px; height:300px;}

/* — Style: Cards ——— */
.zoezi-staff.z-style-cards{text-align:left;}
.zoezi-staff.z-style-cards>h2{margin: 32px 0 0;}
.zoezi-staff.z-style-cards .zoezi-staff-person{background-color:white;border:solid 1px rgba(0,0,0,.2);border-radius:5px;position:relative;box-shadow: 0 1px 3px rgba(0,0,0,.2),0 3px 9px rgba(0,0,0,.15),0 9px 27px rgba(0,0,0,.1);transition:transform 250ms ease-in-out;transition-property: transform, box-shadow, filter;}
.zoezi-staff.z-style-cards:hover .zoezi-staff-person{transform:scale(0.95);filter:blur(1px) grayscale(.2) brightness(.95);}
.zoezi-staff.z-style-cards .zoezi-staff-person:hover{transform:scale(1);filter:blur(0) grayscale(0) brightness(1);box-shadow: 0 1px 13px rgba(0,0,0,.15), 0 3px 19px rgba(0,0,0,.1), 0 9px 37px rgba(0,0,0,.05)}
.zoezi-staff.z-style-cards .zoezi-staff-person>img{width: 100% !important; height: auto !important;border-radius: 5px 5px 0 0;}
.zoezi-staff.z-style-cards .zoezi-staff-person .zoezi-staff-text{position:relative;display:block;padding:16px;}

/* — Style: Sharp ——— */
.zoezi-staff.z-style-sharp{text-align:left;}
.zoezi-staff.z-style-sharp .zoezi-staff-person > img{border-radius:0;width:100% !important; height:auto !important;}
</style>

<template>
    <div class="zoezi-staff" :class="styleClass">
        <h2 v-if="heading">{{heading}}</h2>
        <div v-for="person in staffList" :key="person.id" class="zoezi-staff-person">
            <img v-if="useImage" :src="getImage(person.id)">
            <div class="zoezi-staff-text">
                <h3>{{person.name}}</h3>
                <div v-if="useTags && person.tags && person.tags.length" class="zoezi-staff-tags">
                    <v-chip v-for="tag in person.tags" :key="tag.id" color="primary" variant="tonal" size="x-small" class="ma-1">
                        {{ tag.name }}
                    </v-chip>
                </div>
                <p v-if="useDescription && person.description != null" v-html="person.description"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-staff',

    zoezi: {
        title: 'Staff',
        icon: 'mdi-account-group'
    },

    props: {
        heading: {
            title: 'Heading',
            type: String,
            default: () => window.$translate('Staff')
        },
        useImage: {
            title: 'Show image',
            type: Boolean,
            default: true
        },
        useDescription: {
            title: 'Show description',
            type: Boolean,
            default: true
        },
        useTags: {
            title: 'Show tags',
            type: Boolean,
            default: false
        },
        filterTags: {
            title: 'Filter by tags',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all tags',
                getItems: () => window.$zoeziapi
                .get('/api/systemtag/get')
                .then(all => all.sort((a, b) => a.name.localeCompare(b.name)))
            },
            default: () => []
        },
        selectedStaff: {
            title: 'Staff',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                order: true,
                placeholder: 'Showing all bookable',
                getItems: () => window.$zoeziapi.get('/api/public/staff/get/full').then(staff => staff.sort((a, b) => a.name.localeCompare(b.name)))
            },
            default: () => []
        },
        listStyle: {
            title: 'Appearance',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                text: 'name',
                value: 'id',
                clearable: false,
                placeholder: 'Standard',
                getItems: () => ([
                    {id: 0, name: 'Standard'},
                    {id: 1, name: 'Cards'},
                    {id: 2, name: 'Soft'},
                    {id: 3, name: 'Angular'}
                ].map(x => ({...x, name: window.$translate(x.name)})))
            },
            default: () => 0
        }
    },
    data: () => ({
        staff: []
    }),
    computed: {
        staffList() {
            const list = this.selectedStaff?.length ? this.selectedStaff.map(id => this.staff.find(s => s.id == id)).filter(Boolean) : this.staff;
            return this.filterTags?.length ? list.filter(p => p?.tags?.some(t => this.filterTags.includes(t.id))) : list;
        },
        styleClass() {
            return this.listStyle ?
                'z-style-' + ['default', 'cards', 'soft', 'sharp'][this.listStyle] : 'z-style-default';
        }
    },
    methods: {
        loadStaff() {
            this.$api.get('/api/public/staff/get/full').then(items => this.staff = items.sort((a, b) => a.name.localeCompare(b.name)))
        },
        getImage(id) {
            return `/api/image/get?type=Staff&id=${id}&size=120`
        }
    },
    mounted() {
        this.loadStaff();
    }
}
</script>
